import { Detail } from '../../../pages/FinancialForensicsPage/types/VariableCost.types';
import { CalculationVariables, UnitType } from '../financialForensicsHelper';

export const calculateSum = (calculation: Detail[]): number => {
  return calculation.reduce((sum, detail) => {
    return (
      sum +
      detail.values.reduce((detailSum, val) => {
        return detailSum + (val.value ?? 0);
      }, 0)
    );
  }, 0);
};

export const getCalculationVariables = (
  unit: UnitType,
  context: CalculationVariables,
  details: Detail[],
): CalculationVariables => {
  switch (unit) {
    case 'Per Employee Per Month':
      return {
        employeeCount: calculateSum(details),
        monthCount: context.monthCount ?? 0,
      };

    case 'PEPY':
      return {
        employeeCount: calculateSum(details),
      };

    case 'Per Engaged Member Per Month':
      return {
        engagedMemberCount: calculateSum(details),
        monthCount: context.monthCount ?? 0,
      };

    case 'Per Engaged Member Per Year':
      return {
        engagedMemberCount: calculateSum(details),
        yearCount: context.yearCount ?? 0,
      };

    case 'Per Script':
      return {
        scriptCount: calculateSum(details),
      };

    case 'Per Eligible Claim':
      return {
        claimCount: calculateSum(details),
      };

    case 'Per Case':
      return {
        caseCount: calculateSum(details),
      };

    case 'Per Event':
      return {
        eventCount: calculateSum(details),
      };

    case 'Per Hour':
      return {
        hourCount: calculateSum(details),
      };

    case 'Per Year':
      return {
        yearCount: context.yearCount,
      };

    case 'Flat Monthly Fee':
      return { monthCount: context.monthCount ?? 0 };

    case 'One Time':
      return {};

    case '% of Savings':
      return {
        savingsAmount: calculateSum(details),
      };

    case '% of Paid Claims':
      return {
        paidClaimsAmount: calculateSum(details),
      };

    case '% of Billed Charges':
      return {
        billedChargesAmount: calculateSum(details),
      };

    case '% of Rebate':
      return {
        rebateAmount: calculateSum(details),
      };

    case '% of Fees':
      return {
        vendorFeeAmount: calculateSum(details),
      };

    case 'Basis Points (bps)':
      return {
        baseAmount: calculateSum(details),
      };

    default:
      throw new Error(`Unknown unit type: ${unit}`);
  }
};
